import React from 'react';

export const Sterilization = ({ color }: { color?: string }): JSX.Element => {
    const className = 'icon icon--sterilization';
    color = color || '#0076CC';

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...{ className }}>
            <path d="M21 12C21 10.2191 20.4717 8.47825 19.4818 6.99778C18.492 5.5173 17.0852 4.36377 15.4395 3.68317C13.7938 3.00257 11.9832 2.82551 10.2368 3.17441C8.49045 3.5233 6.88684 4.38245 5.62897 5.64313C4.3711 6.9038 3.51551 8.50932 3.1705 10.2565C2.8255 12.0036 3.00659 13.8138 3.69084 15.458C4.3751 17.1022 5.53176 18.5064 7.01443 19.4929C8.49711 20.4795 10.2391 21.0039 12.02 21M12 6.99981V11.9998L13 12.9998M22 15.9998C22 19.9998 19.5 21.9998 18.5 21.9998C17.5 21.9998 15 19.9998 15 15.9998C16 15.9998 17.5 15.4998 18.5 14.4998C19.5 15.4998 21 15.9998 22 15.9998Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default Sterilization;